import React from 'react';
// @ts-ignore - react-dom/client types not updated yet
import { createRoot } from 'react-dom/client';
import Modal from 'react-modal';
import './index.css';
import App from './App';
// @ts-ignore - serviceWorker.js is a JS file
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import store from './state/store/store';
import InitializeSideEffects from './sideEffects/InitializeSideEffects';
import { ThemeProvider } from 'styled-components';
import theme from './components/shared/Theme/theme';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import loadScript from './utils/loadScript';

loadScript('google-places-api-script', `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_PLACES_KEY}&libraries=places`);

//Register all side effects
InitializeSideEffects();
Modal.setAppElement('#root');

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <Provider store={store}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <App />
                </LocalizationProvider>
            </Provider>
        </ThemeProvider>
    </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
